import styled from '@emotion/styled';
import { r } from '../../../shared/lib/responsive';

export const List = styled.ol`
  position: absolute;
  left: var(--cta-margin-x);
  right: var(--cta-margin-x);
  top: calc(554 / 812 * 100%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  ${r('gap', 8)}
  margin: 0;
  padding: 0;
  list-style: none;
  pointer-events: none;
`;
